import { render, staticRenderFns } from "./IsoDocument.vue?vue&type=template&id=73503c52&"
import script from "./IsoDocument.vue?vue&type=script&lang=js&"
export * from "./IsoDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports